<template>
  <div id="tool-container" v-show="visible">
    <div v-for="(item, index) in toolList" :key="index" class="tool-item"
      :class="{ active: activeToolType === item.type }" @click="handleToolClick(item)" :title="item.name">
      <a-icon :type="getToolIcon(item.type)" />
      <span class="tool-text">{{ item.name }}</span>
    </div>
    <div class="tool-item delete-btn" @click="handleDelete" title="关闭工具栏">
      <a-icon type="close" />
      <span class="tool-text">关闭</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToolContainer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    toolList: {
      type: Array,
      default: () => []
    },
    activeToolType: {
      type: String,
      default: null
    }
  },
  methods: {
    // 获取工具图标
    getToolIcon (type) {
      const iconMap = {
        'measure-distance': 'environment',
        'measure-surface': 'border',
        'analyze-query': 'search',
        'analyze-delete': 'delete',
        'export-image': 'camera',
        'export-print': 'printer',
        'print': 'printer'
      };
      return iconMap[type] || 'tool';
    },

    // 处理工具点击
    handleToolClick (item) {
      this.$emit('tool-item-click', item);
    },

    // 处理删除
    handleDelete () {
      this.$emit('delete-tool');
    }
  }
}
</script>

<style lang="less" scoped>
// 工具容器样式
#tool-container {
  position: absolute;
  bottom: 85px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  padding: 8px 16px;
  gap: 4px;

  .tool-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 8px;
    cursor: pointer;
    border-radius: 12px;
    transition: all 0.3s ease;
    font-size: 12px;
    color: #666;
    min-width: 48px;
    position: relative;

    .anticon {
      font-size: 20px;
      margin-bottom: 0;
    }

    .tool-text {
      position: absolute;
      top: -35px;
      left: 50%;
      transform: translateX(-50%);
      background: rgba(0, 0, 0, 0.8);
      color: white;
      padding: 4px 8px;
      border-radius: 4px;
      font-size: 11px;
      white-space: nowrap;
      opacity: 0;
      visibility: hidden;
      transition: all 0.3s ease;
      z-index: 1001;

      &::after {
        content: '';
        position: absolute;
        bottom: -4px;
        left: 50%;
        transform: translateX(-50%);
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid rgba(0, 0, 0, 0.8);
      }
    }

    &:hover {
      background: rgba(24, 144, 255, 0.1);
      color: #1890ff;
      transform: translateY(-2px);

      .tool-text {
        opacity: 1;
        visibility: visible;
      }
    }

    // 选中状态样式
    &.active {
      background: rgba(24, 144, 255, 0.2);
      color: #1890ff;
      border: 2px solid #1890ff;
      transform: translateY(-2px);

      .tool-text {
        opacity: 0;
        visibility: hidden;
      }

      &:hover .tool-text {
        opacity: 1;
        visibility: visible;
      }
    }

    &:active {
      background: rgba(24, 144, 255, 0.2);
      transform: translateY(0);
    }

    // 删除按钮特殊样式
    &.delete-btn {
      color: #ff4d4f;
      margin-left: 8px;
      border-left: 1px solid rgba(0, 0, 0, 0.1);

      &:hover {
        background: rgba(255, 77, 79, 0.1);
        color: #ff4d4f;
      }

      &:active {
        background: rgba(255, 77, 79, 0.2);
      }
    }
  }
}
</style>
